import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal/modal.component';
import { ModalService } from './modal.service/modal.service';
import { SideModalComponent } from './side-modal/side-modal.component';



@NgModule({
  declarations: [
    ModalComponent,
    SideModalComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ModalComponent,
    SideModalComponent
  ]
})
export class ModalModule { }
